import { useOktaAuth } from '@okta/okta-react';
import { useCallback } from 'react';
import { resetAdviceAdminReducer } from '../../features/adviceAdmin';
import { advisorConsoleActions } from '../../features/advisorConsole';
import { logout } from '../../features/auth/authSlice';
import { initializeAdviceClient } from '../../features/client';
import { initializeGoals } from '../../features/client-goals';
import { resetEws } from '../../features/ews';
import { logEventToBackEnd, updateGlobalLoaderState } from '../../features/global/globalSlice';
import { broadcastLogout } from '../sessionLogout';
import { useAppDispatch } from './index';

export const useLogoutHandler = () => {
    const dispatch = useAppDispatch();
    const { authState, oktaAuth } = useOktaAuth();

    const clearAllStateData = useCallback(async () => {
        dispatch(advisorConsoleActions.resetAdviceConsoleReducer());
        dispatch(initializeAdviceClient());
        dispatch(initializeGoals());
        dispatch(resetEws());
        dispatch(resetAdviceAdminReducer());
        dispatch(logout());
    }, [dispatch]);

    const handleLogout = useCallback(async () => {
        sessionStorage.setItem('isLoggingOut', 'true');
        // Notify other open tabs so they redirect to login too.
        broadcastLogout();

        dispatch(updateGlobalLoaderState({ enabled: true, message: '' }));
        try {
            // Note: signOut will redirect, so code after this might not execute
            await oktaAuth?.signOut({
                clearTokensBeforeRedirect: true,
                postLogoutRedirectUri: window.location.origin + '/login',
                revokeAccessToken: true
            });
            console.log('Okta sign out initiated - clearing state');
            await clearAllStateData();
        } catch (error) {
            console.error('Error during Okta sign out:', error);
            await dispatch(logEventToBackEnd('LOGOUT_ERROR'));
        } finally {
            dispatch(updateGlobalLoaderState(false));
        }
    }, [authState, oktaAuth, dispatch, clearAllStateData]);

    return { handleLogout };
};
